export enum AuthAction {
  Login = 'auth/login',
  Logout = 'auth/logout',
}
